export default __webpack_public_path__ + "static/linkdin-hero-img-0161ca86f98d4047983dab91c895fbcf.png";